export default __webpack_public_path__ + "static/media/151-gardening.21d366eb.png";